import { useMutation } from '@apollo/client'
import React, { useState } from 'react'
import { PUBLISH_USER, UPDATE_PASSWORD } from '../../../../graphql-client/Mutation'
import AvatarForm from './settingForm/AvatarForm'
import CoverForm from './settingForm/CoverForm'
import { GET_AVATAR_USER_MANAGE } from '../../../../graphql-client/Queries'
import './Setting.css'

export default React.memo(function Setting(props) {
  const [fromSettingUser, setFromSettingUser] = useState({
    fromName: '',
  });

  const [passwordInfo, setPasswordInfo] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [settingUser] = useMutation(PUBLISH_USER, {
    variables: {
      username: fromSettingUser.fromName,
    },
    update: (cache, { data: usernameNew }) => {
      cache.writeQuery({
        query: GET_AVATAR_USER_MANAGE,
        data: {
          userManage: usernameNew.publishUser,
        },
      });
    },
  });

  const [changePassword] = useMutation(UPDATE_PASSWORD, {
    variables: {
      oldPassword: passwordInfo.oldPassword,
      newPassword: passwordInfo.newPassword,
    },
    onCompleted: () => {
      alert('Mật khẩu đã được cập nhật thành công');
      setPasswordInfo({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
    },
    onError: (error) => {
      alert(`Có lỗi xảy ra: ${error.message}`);
    },
  });
  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (passwordInfo.newPassword !== passwordInfo.confirmPassword) {
      alert('Mật khẩu mới và xác nhận mật khẩu không khớp.');
      return;
    }
    changePassword();
  };

  return (
    <div className="row setting-page-wrap">
      <div className="col-12 mx-auto">
        <div className="setting-header-card">
          <h3 className="setting-page-title">Thông tin cá nhân</h3>
          <div className="setting-info-box" role="alert">
            <h4><b>Thông tin tài khoản</b></h4>
            <p>
              Để không bị giới hạn các tính năng của nhà phát triển Giáo Dục và nhận được hỗ trợ tốt hơn,
              hãy hoàn thiện tài khoản của bạn và liên hệ qua email: linklearn.hotro@gmail.com hoặc
              zalo: 0837914479.
            </p>
          </div>

          <div className="row g-3 setting-cards-grid">
            <div className="col-12 col-lg-6">
              <section className="setting-card">
                <h5 className="setting-card-title">Cập nhật tên kênh</h5>
                <p className="setting-card-subtitle">Tên kênh hiện tại: {props.nameManager}</p>
                <form
                  action="submit"
                  onSubmit={(e) => {
                    e.preventDefault();
                    settingUser();
                    setFromSettingUser({ fromName: '' });
                    alert('Đã cập nhật thành công');
                  }}
                >
                  <input
                    type="text"
                    name="inputName"
                    id="inputName"
                    className="form-control"
                    placeholder="Nhập vào tên mới của kênh"
                    aria-describedby="helpId"
                    value={fromSettingUser.fromName}
                    onChange={(e) =>
                      setFromSettingUser({
                        ...fromSettingUser,
                        fromName: e.target.value,
                      })
                    }
                  />
                  <button type="submit" className="btn btn-gradient-upload mt-3">
                    Cập nhật tên kênh
                  </button>
                </form>
              </section>
            </div>

            <div className="col-12 col-lg-6">
              <section className="setting-card">
                <h5 className="setting-card-title">Cập nhật mật khẩu</h5>
                <p className="setting-card-subtitle">Dùng mật khẩu đủ mạnh để tăng bảo mật tài khoản.</p>
                <form onSubmit={handlePasswordSubmit}>
                  <div className="form-group mt-1">
                    <label htmlFor="oldPassword">Mật khẩu cũ</label>
                    <input
                      type="password"
                      className="form-control"
                      id="oldPassword"
                      placeholder="Nhập mật khẩu cũ"
                      value={passwordInfo.oldPassword}
                      onChange={(e) =>
                        setPasswordInfo({ ...passwordInfo, oldPassword: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="form-group mt-2">
                    <label htmlFor="newPassword">Mật khẩu mới</label>
                    <input
                      type="password"
                      className="form-control"
                      id="newPassword"
                      placeholder="Nhập mật khẩu mới"
                      value={passwordInfo.newPassword}
                      onChange={(e) =>
                        setPasswordInfo({ ...passwordInfo, newPassword: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="form-group mt-2">
                    <label htmlFor="confirmPassword">Xác nhận mật khẩu mới</label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      placeholder="Xác nhận mật khẩu mới"
                      value={passwordInfo.confirmPassword}
                      onChange={(e) =>
                        setPasswordInfo({ ...passwordInfo, confirmPassword: e.target.value })
                      }
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-gradient-upload mt-3">
                    Cập nhật mật khẩu
                  </button>
                </form>
              </section>
            </div>

            <div className="col-12 col-lg-6">
              <section className="setting-card">
                <h5 className="setting-card-title">Cập nhật ảnh đại diện</h5>
                <p className="setting-card-subtitle">Chọn ảnh rõ nét, vuông để hiển thị đẹp nhất.</p>
                <AvatarForm avatarManager={props.avatarManager} userId={props.id} />
              </section>
            </div>

            <div className="col-12 col-lg-6">
              <section className="setting-card">
                <h5 className="setting-card-title">Cập nhật ảnh bìa</h5>
                <p className="setting-card-subtitle">Ảnh cover nên là ảnh ngang để hiển thị đẹp trên hồ sơ.</p>
                <CoverForm coverManager={props.coverManager} userId={props.id} />
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
